import { Link } from "react-router-dom";

export const Logo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: { x: "text-4xl md:text-5xl", rest: "text-xl md:text-2xl" },
    md: { x: "text-5xl md:text-6xl", rest: "text-2xl md:text-3xl" },
    lg: { x: "text-7xl md:text-8xl", rest: "text-4xl md:text-5xl" },
    xl: { x: "text-8xl md:text-9xl", rest: "text-5xl md:text-7xl" },
  };
  const s = sizes[size];
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      aria-label="X-EROTIC"
      className={`xr-logo inline-flex items-baseline leading-none ${className}`}
    >
      <span className={s.x}>X</span>
      <span className={`${s.rest} ml-[0.15em] tracking-tight uppercase`}>- EROTIC</span>
    </Link>
  );
};

export default Logo;
